function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none" viewBox="0 0 48 48">
      <rect width="48" height="48" fill="#0044F0" rx="8"></rect>
      <path stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M19 14l10 10-10 10"></path>
    </svg>
  );
}

export default Icon;
